import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

type Mode = 'OnDemand' | 'Automated';

interface PatchHeaderProps {
  view: number;
  viewFunction: () => void;
  mode: Mode;
  setMode: (mode: Mode) => void;
}

const PatchHeader: React.FC<PatchHeaderProps> = ({ view, viewFunction, mode, setMode }) => {
  const [activeTab, setActiveTab] = useState<'Explorer' | 'Availability' | 'Activity'>('Activity');

  const navigate = useNavigate();

  const PatchNavigation = () => {
    navigate('/patchCenter');
  };

  const routeAvailability = () => {
    navigate('/patchCenter/AvailabilityPatch');
  };

  return (
    <div className="flex items-center justify-between mb-4">
      {/* Tabs */}
      <div className="flex gap-4 mb-4">
        {['Explorer', 'Availability', 'Activity'].map((tab) => (
          <button
            key={tab}
            onClick={() => {
              setActiveTab(tab as 'Explorer' | 'Availability' | 'Activity');

              if (tab === 'Explorer') PatchNavigation();
              if (tab === 'Availability') routeAvailability();
            }}
            className={`px-4 py-2 rounded-md border-l-[5.62px] border-r-[5.62px] 
              ${activeTab === tab ? 'border-[#D12929] text-white' : 'border-[#474646] text-gray-400'} 
              bg-transparent`}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Right Controls */}
      <div className="flex items-center gap-4">
        {/* 🔥 New Left-Right Toggle */}
        <div className="flex items-center gap-4 mr-6">
          {/* Left Label */}
          <span
            onClick={() => setMode('OnDemand')}
            className={`text-sm cursor-pointer transition ${mode === 'OnDemand' ? 'text-white font-medium' : 'text-gray-400'}`}
          >
            OnDemand
          </span>

          {/* Toggle */}
          <div
            onClick={() => setMode(mode === 'OnDemand' ? 'Automated' : 'OnDemand')}
            className={`w-16 h-8 flex items-center rounded-full p-1 cursor-pointer transition-colors ${
              mode === 'OnDemand' ? 'bg-red-600' : 'bg-red-600'
            }`}
          >
            <div
              className={`bg-white w-6 h-6 rounded-full shadow-md transform transition-transform ${
                mode === 'OnDemand' ? 'translate-x-0' : 'translate-x-8'
              }`}
            />
          </div>

          {/* Right Label */}
          <span
            onClick={() => setMode('Automated')}
            className={`text-sm cursor-pointer transition ${mode === 'Automated' ? 'text-white font-medium' : 'text-gray-400'}`}
          >
            Automated
          </span>
        </div>

        {/* View Switch */}
        <div
          className="flex items-center gap-2 px-3 py-2 border border-gray-600 rounded-lg text-white cursor-pointer bg-transparent"
          onClick={viewFunction}
        >
          <span className="text-gray-400">{view ? 'Switch to grid view' : 'Switch to table view'}</span>
        </div>
      </div>
    </div>
  );
};

export default PatchHeader;
